import { api } from '../lib/api';

export const nichesService = {
  async listNiches() {
    const response = await api.get('/api/niches');
    return response.data;
  }
};

export default nichesService;
